// extracted by mini-css-extract-plugin
export var productImage = "_gn-1";
export var viewLink = "_gn-2";
export var wishlistItem = "_gn-0";